module.exports = __webpack_public_path__ + "img/icon-escalated-green.3d5f49d0.svg";